import Vue from 'vue'
import VueRouter from 'vue-router'
import Routes from './routes'

Vue.use(VueRouter)

const Router = new VueRouter({
    mode: 'history',
    routes: Routes
})

// Router.beforeResolve((to, from, next) => {
//     let status = Store.getters['auth/getAuthStatus'];
//     if (to.meta.public || status === AuthStatus.AUTHORIZED) {
//         next();
//     } else if (from.name !== "login" && status === AuthStatus.UNAUTHORIZED) {
//         next({name: "login"});
//     } else if (from.name !== "initialize" && status === AuthStatus.UNKNOWN) {
//         next({name: "initialize"});
//     }
// })

export default Router